<div class="flex flex-col">
    <!-- Header -->
    <div class="flex flex-0 sticky top-0 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium space-x-4">
            <b>{{ displayRow().empresaName }}</b>
            @if (rowIsConceptSummary(displayRow())) {
                <b>{{ displayRowAsConceptSummary().workplaceCode }}</b>
            } @else {
                <b>{{ getGuideWorkplace(displayRowAsMonthlyContractWorkConceptSummary()) }}</b>
            }
            <span>{{ displayRow().displayName }}</span>
            <span>DNI: {{ displayRow().sAMAccountName }}</span>
            <span>Net4ID: {{ displayRow().trabajadorNet4Id }}</span>
        </div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <div class="flex gap-2 p-8">
        <div class="flex flex-col w-1/3 2xl:w-1/4">
            @for (control of conceptsForm.controls; track control; let index = $index) {
                <div class="w-full flex flex-col">
                    <h2>
                        {{ displayConcepts()[index].conceptName }}
                        @if (displayConcepts()[index].type === 'TIME') {
                            @switch (displayConcepts()[index].format) {
                                @case ('MINUTES') {
                                    ({{ 'conceptSummary.minutes' | transloco }})
                                }
                                @case ('HOURS') {
                                    ({{ 'conceptSummary.hours' | transloco }})
                                }
                                @case ('WORKDAYS') {
                                    ({{ 'conceptSummary.workdays' | transloco }})
                                }
                            }
                        }
                    </h2>
                    <div class="w-full flex flex-col xl:flex-row px-4 py-2 gap-2 xl:gap-4">
                        @switch (displayConcepts()[index].type) {
                            @case ('BOOLEAN') {
                                <mat-slide-toggle class="w-1/2" [formControl]="control.get('value')">{{ 'conceptSummary.value' | transloco }}</mat-slide-toggle>
                                <mat-slide-toggle class="w-1/2" [formControl]="control.get('calculatedValue')">{{ 'conceptSummary.calculatedValue' | transloco }}</mat-slide-toggle>
                            }
                            @case ('INTEGER') {
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.value' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('value')" type="number">
                                </mat-form-field>
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.calculatedValue' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('calculatedValue')" type="number">
                                </mat-form-field>
                            }
                            @case ('TIME') {
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.value' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('value')" type="number">
                                </mat-form-field>
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.calculatedValue' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('calculatedValue')" type="number">
                                </mat-form-field>
                            }
                            @case ('DOUBLE') {
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.value' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('value')" type="number">
                                </mat-form-field>
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.calculatedValue' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('calculatedValue')" type="number">
                                </mat-form-field>
                            }
                            @case ('PERCENT') {
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.value' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('value')" type="number">
                                    <mat-icon matSuffix [svgIcon]="'feather:percent'"></mat-icon>
                                </mat-form-field>
                                <mat-form-field class="w-1/2">
                                    <mat-label>{{ 'conceptSummary.calculatedValue' | transloco }}</mat-label>
                                    <input matInput [formControl]="control.get('calculatedValue')" type="number">
                                    <mat-icon matSuffix [svgIcon]="'feather:percent'"></mat-icon>
                                </mat-form-field>
                            }
                        }
                    </div>
                </div>
            }
        </div>
        @if (displayRow().summaryRow) {
            <div class="flex flex-col items-start flex-1">
                <div class="flex flex-wrap">
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.totalHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.minutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.minutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.contractHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.contractMinutesAccumulated !== 0) {
                                {{ minutesToText(displayRow().summaryRow.contractMinutesAccumulated) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.workedHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.workedMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.workedMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.justifiedAbsenceHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.minutesJustified !== 0) {
                                {{ minutesToText(displayRow().summaryRow.minutesJustified) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.periodHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.contractPeriodMinutesAccumulated !== 0) {
                                {{ minutesToText(displayRow().summaryRow.contractPeriodMinutesAccumulated) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'payrollViews.hourBagCompensate' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.compensationBagMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.compensationBagMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.complementaryHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.complementaryMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.complementaryMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'payrollViews.complementaryPlusMinutes' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.complementaryPlusMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.complementaryPlusMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.extraHours' | transloco }}
                        </div>
                        <div class="flex flex-col justify-center items-center flex-none h-24 p-2 border border-current">
                            <span>{{ minutesToText(displayRow().summaryRow.extraMinutes) }}</span>
                            <span>
                                {{ minutesToText(displayRow().summaryRow.annualExtraMinutes) }} de {{ minutesToText(displayRow().summaryRow.maxAnnualExtraMinutes) }}
                            </span>
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.extraPlusHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.extraPlusMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.extraPlusMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.nightHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.nightMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.nightMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.holidayHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.nonWorkableMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.nonWorkableMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.saturdayOffsetHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.saturdayOffsetMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.saturdayOffsetMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.sundayOffsetHours' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            @if (displayRow().summaryRow.sundayOffsetMinutes !== 0) {
                                {{ minutesToText(displayRow().summaryRow.sundayOffsetMinutes) }}
                            }
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.vacationDays' | transloco }}
                        </div>
                        <div class="flex flex-col justify-center items-center flex-none h-24 p-2 border border-current">
                            <span>{{ displayRow().summaryRow.vacationDays }}</span>
                            <span>
                                {{ displayRow().summaryRow.annualVacationsDays }} de {{ displayRow().summaryRow.maxAnnualVacationDays }}
                            </span>
                            <span>{{ displayRow().summaryRow.vacationDaysType ? (('vacations.' + displayRow().summaryRow.vacationDaysType ) | transloco) : '' }}</span>
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.plusMonthlyRatioOffsetMinutesAdj' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ minutesToText(displayRow().summaryRow.plusMonthlyRatioOffsetMinutesAdj) }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.plusMonthlyTimeOffsetMinutesAdj' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ minutesToText(displayRow().summaryRow.plusMonthlyTimeOffsetMinutesAdj) }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.supervisorPlusMinutes' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ minutesToText(displayRow().summaryRow.supervisorPlusMinutes) }}
                        </div>
                    </div>
                    <!--
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.supervisorPlusWithAttendance' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ displayRow().summaryRow.supervisorPlusWithAttendance }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.withAttendance' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ displayRow().summaryRow.withAttendance }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.saturdayWithAttendance' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ displayRow().summaryRow.saturdayWithAttendance }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.sundayWithAttendance' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ displayRow().summaryRow.sundayWithAttendance }}
                        </div>
                    </div>
                    <div class="flex flex-col w-32">
                        <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                            {{ 'conceptSummary.holidayWithAttendance' | transloco }}
                        </div>
                        <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                            {{ displayRow().summaryRow.holidayWithAttendance }}
                        </div>
                    </div> -->
                </div>

                <div class="flex flex-col 2xl:flex-row mt-8 items-start flex-1">
                    <div>
                        <h2 class="text-2xl text-primary 2xl:justify-end">
                            {{ "payrollViews.hoursBag" | transloco }}
                        </h2>
                        <div class="flex">
                            <div class="flex flex-col w-32">
                                <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'payrollViews.hourBagPrev' | transloco }}
                                </div>
                                <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                                    @if (displayRow().summaryRow.previousBagMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.previousBagMinutes) }}
                                    }
                                </div>
                            </div>
                            <div class="flex flex-col w-32">
                                <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'payrollViews.hourBagCurrent' | transloco }}
                                </div>
                                <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                                    @if ((displayRow().summaryRow.currentBagMinutes - displayRow().summaryRow.previousBagMinutes) !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.currentBagMinutes - displayRow().summaryRow.previousBagMinutes) }}
                                    }
                                </div>
                            </div>
                            <div class="flex flex-col w-32">
                                <div class="flex-none text-center h-20 p-2 border border-secondary text-md text-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'payrollViews.hourBag' | transloco }}
                                </div>
                                <div class="flex justify-center items-center flex-none h-24 p-2 border border-current">
                                    {{ minutesToText(displayRow().summaryRow.currentBagMinutes) }}
                                    @if (isWithinCurrentOrPreviousMonth) {
                                        <button mat-icon-button (click)="openWorkerRegularizeHourBagDialog(displayRow().summaryRow)" [matTooltip]="'workerHourBag.toCompensate' | transloco">
                                            <mat-icon [svgIcon]="'mat_outline:edit'"></mat-icon>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2 class="text-2xl text-primary text-center 2xl:justify-end mt-10 2xl:mt-0">
                            {{ monthYearTitle }}
                        </h2>
                        <div class="flex flex-col">
                            <div class="flex justify-normal 2xl:justify-end h-12 text-md text-secondary">
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.L' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.M' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.X' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.J' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.V' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.S' | transloco }}
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    {{ 'conceptSummary.D' | transloco }}
                                </div>
                            </div>
                            <div class="flex justify-normal 2xl:justify-end flex-wrap">
                                @for (day of days(); track day) {
                                    <div class="flex flex-col w-[14%]">
                                        <div class="flex justify-center items-center w-full h-12 p-2 bg-gray-200 dark:bg-slate-700 border border-current"
                                            [ngClass]="{ 'bg-gray-400 dark:bg-slate-500': isHoliday(day) }">
                                            @if (!hideDay(day)) {
                                                {{ day | localizeDate: 'dd' }}
                                            }
                                        </div>
                                        <div class="w-full h-12 border border-current">
                                            @if (getDayWorkedHours(day); as workDay) {
                                                <div class="flex flex-col justify-center items-center w-full h-full p-2" [ngClass]="{ 'bg-gray-400 dark:bg-slate-500': workDay.holiday && !workDay.workable }">
                                                    @if (workDay.workedMinutes !== 0) {
                                                        <span>{{ minutesToHours(workDay.workedMinutes) }}</span>
                                                    }
                                                    @for (entry of getMapValues(workDay); track entry[0]) {
                                                        <span>{{ entry[0] }}: {{ minutesToHours(entry[1]) }}</span>
                                                    }
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>

                            <div class="flex justify-normal 2xl:justify-end h-12 text-md text-secondary">
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.mondayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.mondayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.tuesdayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.tuesdayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.wednesdayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.wednesdayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.thursdayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.thursdayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.fridayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.fridayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.saturdayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.saturdayMinutes) }}
                                    }
                                </div>
                                <div class="flex justify-center items-center w-[14%] p-2 border border-secondary shadow bg-gray-50 dark:bg-slate-900">
                                    @if (displayRow().summaryRow.sundayMinutes !== 0) {
                                        {{ minutesToText(displayRow().summaryRow.sundayMinutes) }}
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="flex justify-between p-4 sticky bottom-0 bg-white dark:bg-slate-800">
        <a class="cursor-pointer text-blue-500 underline px-4" (click)="openWorkerAssignmentsDialog()">{{ data.dayOfMonth ? ('conceptSummary.goToDayAssignments' | transloco) : ('conceptSummary.goToAssignments' | transloco) }}</a>
        <div class="flex">
            <button class="mr-2" mat-raised-button color="warn" (click)="closeDialog()">
                {{ 'cancel' | transloco }}
            </button>
            <button class="mr-2" mat-raised-button color="primary" (click)="accept()" [disabled]="conceptsForm.pristine">
                {{ 'accept' | transloco }}
            </button>
        </div>
    </div>
</div>
